import styled from "styled-components";

import vars from "variables";

import search from "assets/Layout/Dashboard/Sidebar/Wallets/search.svg";
import wallet from "assets/Layout/Dashboard/Sidebar/Wallets/wallet.svg";
import close from "assets/Common/ReactModal/close.svg";

const Root = styled.main`
  ${vars.desktop.mediaQuery} {
    div.connect,
    div.connected,
    div.search {
      width: 200px;
      padding: 24px 22px;
      display: inline-block;
      font-size: 0.8rem;
      font-weight: 600;
      letter-spacing: 0.5px;
      line-height: 1rem;
      text-transform: uppercase;
      position: relative;
      background: ${vars.colors.blue};
      border-radius: 8px;
    }

    div.connect,
    div.search {
      cursor: pointer;
      text-align: center;
    }

    div.connect span {
      padding-left: 30px;
      background-image: url(${wallet});
      background-repeat: no-repeat;
    }

    div.connected span {
      width: 185px;
      margin-bottom: -4px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    div.search {
      margin-top: 18px;
      background: ${vars.colors.background};
    }

    div.search span {
      padding-left: 30px;
      background-image: url(${search});
      background-repeat: no-repeat;
      background-position: 6px center;
    }

    .close {
      top: calc(50% - 10px);
      right: 16px;
      width: 20px;
      height: 20px;
      margin-left: auto;
      cursor: pointer;
      display: inline-block;
      position: absolute;
      background: url(${close}) no-repeat;
      background-size: cover;
    }
  }

  ${vars.mobile.mediaQuery} {
    div.connect,
    div.search {
      margin-top: 4px;
      margin-bottom: -4px;
      margin-left: 15px;
      width: 20px;
      height: 20px;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 20px;
    }

    div.connect {
      background-color: ${vars.colors.blue};
      mask-image: url(${wallet});
    }

    div.search {
      background-image: url(${search});
    }

    div.connect span,
    div.connected span,
    div.search span {
      font-size: 0;
      position: fixed;
    }
  }
`;

export { Root };
